import * as $ from 'jquery';
import { Bouncer as bouncer } from '../newsletterPopup/Bouncer';
import { recaptcha } from '../../utils/functions';
import { LarchSys } from '../../utils/larchSys';
import { BounceWatcher } from '../newsletterPopup/BounceWatcher';


export function newsletterBlock(larchSys: LarchSys) {

    $('.module-newsletterblock').each(function () {
        var $module = $(this);
        var $form = $module.find<HTMLFormElement>('.nl-form');

        loading(false);
        showForm();

        bouncer('.module-newsletterblock .nl-form', { disableSubmit: true });

        $form.on("bouncerFormValid", e => {
            e.preventDefault();

            hideError();
            loading(true);

            recaptcha($form.find('grecaptcha')[0]).then(() => {
                const form = $form[0];

                window.fetch(form.action, { method: form.method, body: new FormData(form) })
                    .then(response => {
                        if (response.ok) return response.json();
                        else return response.text()
                            .then(json => Promise.resolve().then(_ => JSON.parse(json).error as string).catch(_ => json))
                            .then(error => { throw error; });
                    })
                    .then(data => {
                        if (data.success) {
                            showSuccess();
                            new BounceWatcher('nlppp-disabled').disable(365);
                        }
                        else {
                            throw data.error;
                        }
                    })
                    .catch(error => {
                        showError(error || 'Error');
                    })
                    .finally(() => {
                        loading(false);
                    });

            });
        });


        function showForm() {
            $module.find('.nl-success').hide();
            $module.find('.nl-errors').hide();
            $module.find('.nl-form').show();
        }

        function showSuccess() {
            $module.find('.nl-success').show();
            $module.find('.nl-errors').hide();
            $module.find('.nl-form').hide();
        }

        function showError(error: string) {
            $module.find('.nl-errors').show();
            $module.find('.nl-errors').html(error);
        }

        function hideError() {
            $module.find('.nl-errors').hide();
            $module.find('.nl-errors').html('');
        }

        function loading(show: boolean) {
            const btn = $module.find<HTMLInputElement>('.nl-submit')[0];
            if(show) {
                btn.querySelector('.load-spinner').classList.add('spin');
                btn.disabled = true;
            }
            else {
                btn.querySelector('.load-spinner').classList.remove('spin');
                btn.disabled = false;
            }
        }

    });

}